<template>

  <div :class="'mes' + (type ? ' ' + type : '')"> 

    <i v-if="icon" :class="icon"></i>
    <div class="text">
      <slot></slot>
    </div>
    
    <UiButton
      v-if="buttonName"
      :name="buttonName"
      :type="buttonType"
      @click="emits('click-button')"
      />

  </div>
  
</template>


<script setup lang="ts">

interface PageProps {
  icon?: string,
  type?: string,
  buttonName?: string,
  buttonType?: string  
}

const props = withDefaults(defineProps<PageProps>(), {
  icon: '',
  type: '',
  buttonName: '',
  buttonType: ''
})

const emits = defineEmits(['click-button']);

</script>
 

 
<style scoped>

.mes{    
  background-color: #f6f6f6;
  padding: 0.3rem 1rem;
  border-radius: 5px;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-top: 0.5rem;
  gap: 1rem;
}

.orange:deep(.btn),
.orange{    
  background-color: #FFF8DB;
  color: #B58105;
}

.green:deep(.btn), 
.green{    
  background-color: #00895717;
  color: #008957;
}

.blue:deep(.btn), 
.blue{
  color: #5078A2;
  background-color: #D2E8F4;
}
  
.mes .icon{
  flex-shrink: 0;
}
.mes .text{
  margin-right: auto;
}




</style>